import type { MemoryStore } from './memory-store';
import { createMemoryStore } from './memory-store';

class StringMemory {
  private readonly storePromise: Promise<MemoryStore>;

  constructor(storage: Storage) {
    // Namespace all keys with "memory-"
    this.storePromise = createMemoryStore('memory', storage);
  }

  async get<T extends () => string | Promise<string>>(key: string, callback: T) {
    let item: string | null = null;
    try {
      const store = await this.storePromise;
      item = await store.getItem(key);
    } catch {
      // Ignore store read errors; we will fetch fresh below
    }

    if (item) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log(
          `Fetched key "${key}" correctly, but did not return the stored response. Use production environment to enable.`,
        );
        return callback();
      }
      return item;
    }

    const result = await callback();

    try {
      const store = await this.storePromise;
      await store.setItem(key, result);
    } catch {
      // Swallow any caching errors (quota, blocked storage, etc.)
    }

    return result;
  }

  delete(key: string) {
    void this.storePromise.then((store) => store.removeItem(key)).catch(() => {
      // ignore delete errors
    });
  }
}

export default (storage: Storage) => new StringMemory(storage);
